import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ rating, size = 'md', interactive = false, onRate = () => {} }) => {
  const sizeClasses = {
    sm: 'h-3.5 w-3.5',
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };

  const starSize = sizeClasses[size] || sizeClasses.md;

  return (
    <div className="flex items-center gap-0.5" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => interactive && onRate(star)}
          disabled={!interactive}
          className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'}`}
          data-testid={`star-${star}`}
        >
          <Star
            className={`${starSize} ${
              star <= rating
                ? 'fill-[#FFB800] text-[#FFB800]'
                : 'fill-transparent text-[#D4D4D4]'
            }`}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
